import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { BlindsChangedEvent, CurtainChangedEvent } from '../../../shared/events';
import { selectCurrentBlinds } from './blinds-store/blinds.selector';
import { BlindsComponent } from './blinds.component';
import { selectCurrentCurtains } from './curtains-store/curtains.selector';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-blinds',
  templateUrl: './blinds.container.html',
  imports: [BlindsComponent, AsyncPipe],
})
export class BlindsContainerComponent {
  private readonly store = inject(Store);

  public readonly currentBlindPosition$: Observable<number>;
  public readonly currentCurtainPosition$: Observable<number>;

  constructor() {
    this.currentBlindPosition$ = this.store.select(selectCurrentBlinds).pipe(
      filter((y) => y?.Position !== undefined),
      map((blind: BlindsChangedEvent) => Math.round((1 - blind.Position) * 100))
    );

    this.currentCurtainPosition$ = this.store.select(selectCurrentCurtains).pipe(
      filter((y) => y?.Position !== undefined),
      map((blind: CurtainChangedEvent) => Math.round((1 - blind.Position) * 100))
    );
  }
}
